import { type Address, type FormErrors, type InputFormData, PropertyType } from './inputForm';

const isNonEmptyString = (value: unknown): value is string => typeof value === 'string' && value.length > 0;

const isAtLeastOne = (value: unknown): boolean => typeof value === 'number' && value >= 1;

const isOptionalNonNegativeNumber = (value: string | null | undefined): boolean =>
    !value || (!Number.isNaN(Number(value)) && Number(value) > -1);

export function isValidAddress(address: Partial<Address> | undefined): boolean {
    return (
        isNonEmptyString(address?.name) &&
        isNonEmptyString(address?.label) &&
        isNonEmptyString(address?.municipalityName) &&
        isAtLeastOne(address?.lat) &&
        isAtLeastOne(address?.lon)
    );
}

function validateSize(size: string | undefined): string | undefined {
    if (!isNonEmptyString(size)) return 'Du må fylle inn en gyldig størrelse';
    if (Number.isNaN(Number(size)) || Number(size) <= 0) return 'Størrelsen må være et positivt tall';
    return undefined;
}

export function validateInputForm(data: InputFormData): FormErrors | undefined {
    const errors: FormErrors = {};

    if (!isValidAddress(data.address)) errors.address = 'Adresse er påkrevd';

    const sizeError = validateSize(data.size);
    if (sizeError) errors.size = sizeError;

    if (!Object.values<string | undefined>(PropertyType).includes(data.propertyType)) {
        errors.propertyType = 'Du må velge en boligtype';
    }
    if (!isOptionalNonNegativeNumber(data.floor)) errors.floor = 'Etasje må være et positivt tall';
    if (!isOptionalNonNegativeNumber(data.bedrooms)) errors.bedrooms = 'Antall soverom må være et positivt tall';

    return Object.keys(errors).length ? errors : undefined;
}
